var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_7214",
    "data-name": "Groupe 7214",
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.44,
    height: 124.44,
    viewBox: "0 0 124.44 124.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10180",
    "data-name": "Trac\\xE9 10180",
    d: "M12.444,12.444h6.222V0H9.333A9.333,9.333,0,0,0,0,9.333v9.333H12.444Z",
    fill: "#b5b5b5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10181",
    "data-name": "Trac\\xE9 10181",
    d: "M128,12.444h18.666V0H128Z",
    transform: "translate(-96.89)",
    fill: "#b5b5b5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10182",
    "data-name": "Trac\\xE9 10182",
    d: "M274.666,12.444H256V0h18.666Z",
    transform: "translate(-193.78)",
    fill: "#b5b5b5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10183",
    "data-name": "Trac\\xE9 10183",
    d: "M0,128v18.666H12.444V128Z",
    transform: "translate(0 -96.89)",
    fill: "#b5b5b5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10184",
    "data-name": "Trac\\xE9 10184",
    d: "M0,256v18.666H12.444V256Z",
    transform: "translate(0 -193.78)",
    fill: "#b5b5b5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10185",
    "data-name": "Trac\\xE9 10185",
    d: "M422.044,128H409.6v18.666h12.444Z",
    transform: "translate(-310.048 -96.89)",
    fill: "#b5b5b5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10186",
    "data-name": "Trac\\xE9 10186",
    d: "M128,422.044h18.666V409.6H128Z",
    transform: "translate(-96.89 -310.048)",
    fill: "#b5b5b5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10187",
    "data-name": "Trac\\xE9 10187",
    d: "M0,396.444a6.222,6.222,0,0,0,6.222,6.222H18.666V390.222H12.444V384H0Z",
    transform: "translate(0 -290.67)",
    fill: "#b5b5b5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10188",
    "data-name": "Trac\\xE9 10188",
    d: "M390.222,18.666V12.444H384V0h9.333a9.333,9.333,0,0,1,9.333,9.333v9.333Z",
    transform: "translate(-290.67)",
    fill: "#b5b5b5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10189",
    "data-name": "Trac\\xE9 10189",
    d: "M144.8,164.62H111.733a9.333,9.333,0,0,1-9.333-9.333V111.733a9.333,9.333,0,0,1,9.333-9.333h43.554a9.333,9.333,0,0,1,9.333,9.333V144.8l34.3,15.59a5.176,5.176,0,0,1,.173,9.341l-18.031,9.016a5.177,5.177,0,0,0-2.315,2.315l-9.016,18.031a5.176,5.176,0,0,1-9.341-.173Zm-5.656-12.444-5.15-11.331a5.176,5.176,0,0,1,6.853-6.853l11.331,5.15v-24.3H114.844v37.332Z",
    transform: "translate(-77.512 -77.512)",
    fill: "#b5b5b5",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/UploadFile.9804f6a56792f8b2ced6d60803d555d9.svg";
export { ForwardRef as ReactComponent };